import React from 'react';
import { Typography, Box } from '@mui/material';
import Sidebar from '../components/Sidebar';
import ClientView from '../components/ClientView';

const ClientDashboard: React.FC = () => {
  return (
    <Box sx={{ display: 'flex' }}>
   
     
  
        <ClientView />
    
    </Box>
  );
};

export default ClientDashboard;